<main class="c-main">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
        {{ erro }}
      </div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>person</mat-icon></div>
          <mat-card-title>
            Usuário
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
            <div class="col-1">
              <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                <mat-label>ID</mat-label>
                <input formControlName="id" matInput readonly>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                <mat-label>Username</mat-label>
                <input formControlName="username" matInput required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                <mat-label>Senha</mat-label>
                <input matInput formControlName="password"
                  [type]="hide ? 'password' : 'text'" required>
                <button mat-icon-button matSuffix type="button" (click)="hide = !hide"
                  [attr.aria-label]="'Ocultar senha'" [attr.aria-pressed]="hide">
                  <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                <mat-label>Nome</mat-label>
                <input formControlName="name" matInput required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" style="width: 100%;" appearance="fill">
                <mat-label>Perfil de Acesso</mat-label>
                <mat-select formControlName="perfil" [compareWith]="compararCampos" required>
                  <mat-option *ngFor="let perfil of perfis" [value]="perfil.id">
                    {{ perfil.nome }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-1">
              <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Ativo</mat-label>
                <mat-select formControlName="ativo" required>
                  <mat-option [value]="true">Sim</mat-option>
                  <mat-option [value]="false">Não</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" (click)="limpar()" mat-stroked-button>
              <mat-icon>insert_drive_file</mat-icon> Limpar
            </button>
            <button [disabled]="!formulario.valid" mat-raised-button color="primary" type="submit">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
          </form>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
